/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  GenerateInvoicesRequest,
  GetFamilyPaymentAllocationResponse,
  GetInvoicesRequest,
  GetPaymentByUserIdRequest,
  GetPaymentResponse,
  GetTerminalResponse,
  InvoiceActionResponse,
  InvoiceResponse,
  InvoiceSummaryResponse,
  OpenBalanceResponse,
  PaginatedResultOfGetPaymentResponse,
  PaginatedResultOfInvoiceResponse,
  PaymentWorkItemResponse,
  ProblemDetails,
  RebuildCoverageRequest,
  RefundPaymentRequest,
  ReleaseFamilyPaymentRequest,
  ReleasePaymentRequest,
  Result,
  ScrollPaymentsQuery,
  SendStatementEmailRequest,
  StatementEmailResponse,
  ValidateSurchargeRequest,
  VerifyPayJunctionRequest,
  VerifyPayJunctionResponse,
  VoidPaymentRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    GenerateInvoicesRequestFromJSON,
    GenerateInvoicesRequestToJSON,
    GetFamilyPaymentAllocationResponseFromJSON,
    GetFamilyPaymentAllocationResponseToJSON,
    GetInvoicesRequestFromJSON,
    GetInvoicesRequestToJSON,
    GetPaymentByUserIdRequestFromJSON,
    GetPaymentByUserIdRequestToJSON,
    GetPaymentResponseFromJSON,
    GetPaymentResponseToJSON,
    GetTerminalResponseFromJSON,
    GetTerminalResponseToJSON,
    InvoiceActionResponseFromJSON,
    InvoiceActionResponseToJSON,
    InvoiceResponseFromJSON,
    InvoiceResponseToJSON,
    InvoiceSummaryResponseFromJSON,
    InvoiceSummaryResponseToJSON,
    OpenBalanceResponseFromJSON,
    OpenBalanceResponseToJSON,
    PaginatedResultOfGetPaymentResponseFromJSON,
    PaginatedResultOfGetPaymentResponseToJSON,
    PaginatedResultOfInvoiceResponseFromJSON,
    PaginatedResultOfInvoiceResponseToJSON,
    PaymentWorkItemResponseFromJSON,
    PaymentWorkItemResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RebuildCoverageRequestFromJSON,
    RebuildCoverageRequestToJSON,
    RefundPaymentRequestFromJSON,
    RefundPaymentRequestToJSON,
    ReleaseFamilyPaymentRequestFromJSON,
    ReleaseFamilyPaymentRequestToJSON,
    ReleasePaymentRequestFromJSON,
    ReleasePaymentRequestToJSON,
    ResultFromJSON,
    ResultToJSON,
    ScrollPaymentsQueryFromJSON,
    ScrollPaymentsQueryToJSON,
    SendStatementEmailRequestFromJSON,
    SendStatementEmailRequestToJSON,
    StatementEmailResponseFromJSON,
    StatementEmailResponseToJSON,
    ValidateSurchargeRequestFromJSON,
    ValidateSurchargeRequestToJSON,
    VerifyPayJunctionRequestFromJSON,
    VerifyPayJunctionRequestToJSON,
    VerifyPayJunctionResponseFromJSON,
    VerifyPayJunctionResponseToJSON,
    VoidPaymentRequestFromJSON,
    VoidPaymentRequestToJSON,
} from '../models/index';

export interface ApiPaymentsExternalTerminalsGetRequest {
    xTenantID?: number;
}

export interface ApiPaymentsFamilyPaymentAllocationGetRequest {
    userId?: ApiUserTasksGetPageParameter;
    currency?: string;
    billingDate?: any;
    xTenantID?: number;
}

export interface ApiPaymentsIdGetRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesGeneratePostRequest {
    generateInvoicesRequest: GenerateInvoicesRequest;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesInvoiceIdDeleteRequest {
    invoiceId: number;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesInvoiceIdGetRequest {
    invoiceId: number;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesInvoiceIdReleasePostRequest {
    invoiceId: number;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesInvoiceIdStatementPostRequest {
    invoiceId: number;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesPostRequest {
    getInvoicesRequest: GetInvoicesRequest;
    xTenantID?: number;
}

export interface ApiPaymentsInvoicesSummaryGetRequest {
    invoiceDate?: any;
    billingDate?: any;
    xTenantID?: number;
}

export interface ApiPaymentsOpenBalanceGetRequest {
    billingDate?: any;
    userId?: ApiUserTasksGetPageParameter;
    studentId?: ApiUserTasksGetPageParameter;
    currency?: string;
    xTenantID?: number;
}

export interface ApiPaymentsRebuildBalanceStudentIdPutRequest {
    studentId: number;
    rebuildCoverageRequest: RebuildCoverageRequest;
    xTenantID?: number;
}

export interface ApiPaymentsRebuildCoverageStudentIdPutRequest {
    studentId: number;
    rebuildCoverageRequest: RebuildCoverageRequest;
    xTenantID?: number;
}

export interface ApiPaymentsReconcileStudentIdPutRequest {
    studentId: number;
    xTenantID?: number;
}

export interface ApiPaymentsRefundPutRequest {
    refundPaymentRequest: RefundPaymentRequest;
    xTenantID?: number;
}

export interface ApiPaymentsReleaseFamilyPaymentPostRequest {
    releaseFamilyPaymentRequest: ReleaseFamilyPaymentRequest;
    xTenantID?: number;
}

export interface ApiPaymentsReleasePostRequest {
    releasePaymentRequest: ReleasePaymentRequest;
    xTenantID?: number;
}

export interface ApiPaymentsScrollPostRequest {
    scrollPaymentsQuery: ScrollPaymentsQuery;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiPaymentsStatementEmailPostRequest {
    sendStatementEmailRequest: SendStatementEmailRequest;
    xTenantID?: number;
}

export interface ApiPaymentsStatusWorkItemIdGetRequest {
    workItemId: string;
    xTenantID?: number;
}

export interface ApiPaymentsStatusWorkItemIdRetryPostRequest {
    workItemId: string;
    xTenantID?: number;
}

export interface ApiPaymentsSurchargeDisclosureValidatePostRequest {
    validateSurchargeRequest: ValidateSurchargeRequest;
    xTenantID?: number;
}

export interface ApiPaymentsUserUserIdGetRequest {
    userId: number;
    getPaymentByUserIdRequest: GetPaymentByUserIdRequest;
    xTenantID?: number;
}

export interface ApiPaymentsVerifyPostRequest {
    verifyPayJunctionRequest: VerifyPayJunctionRequest;
    xTenantID?: number;
}

export interface ApiPaymentsVoidPutRequest {
    voidPaymentRequest: VoidPaymentRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class PaymentApi extends runtime.BaseAPI {

    /**
     * Retrieves a list of all external terminals. Configured by payment provider.
     * Get external terminals
     */
    async apiPaymentsExternalTerminalsGetRaw(requestParameters: ApiPaymentsExternalTerminalsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTerminalResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/external-terminals`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTerminalResponseFromJSON));
    }

    /**
     * Retrieves a list of all external terminals. Configured by payment provider.
     * Get external terminals
     */
    async apiPaymentsExternalTerminalsGet(requestParameters: ApiPaymentsExternalTerminalsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTerminalResponse>> {
        const response = await this.apiPaymentsExternalTerminalsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the outstanding balance for each student in the family account.
     * Get family payment allocation
     */
    async apiPaymentsFamilyPaymentAllocationGetRaw(requestParameters: ApiPaymentsFamilyPaymentAllocationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFamilyPaymentAllocationResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['UserId'] = requestParameters['userId'];
        }

        if (requestParameters['currency'] != null) {
            queryParameters['Currency'] = requestParameters['currency'];
        }

        if (requestParameters['billingDate'] != null) {
            queryParameters['BillingDate'] = requestParameters['billingDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/family-payment-allocation`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFamilyPaymentAllocationResponseFromJSON));
    }

    /**
     * Gets the outstanding balance for each student in the family account.
     * Get family payment allocation
     */
    async apiPaymentsFamilyPaymentAllocationGet(requestParameters: ApiPaymentsFamilyPaymentAllocationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFamilyPaymentAllocationResponse>> {
        const response = await this.apiPaymentsFamilyPaymentAllocationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint allows you to fetch payment transactions associated with a particular ID.
     * Get payment by ID
     */
    async apiPaymentsIdGetRaw(requestParameters: ApiPaymentsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPaymentsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint allows you to fetch payment transactions associated with a particular ID.
     * Get payment by ID
     */
    async apiPaymentsIdGet(requestParameters: ApiPaymentsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentResponse> {
        const response = await this.apiPaymentsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiates invoice generation based on the specified criteria and returns the identifiers of the invoices queued for generation.
     * Generate invoices
     */
    async apiPaymentsInvoicesGeneratePostRaw(requestParameters: ApiPaymentsInvoicesGeneratePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApiUserTasksGetLastSelectedIdParameter>>> {
        if (requestParameters['generateInvoicesRequest'] == null) {
            throw new runtime.RequiredError(
                'generateInvoicesRequest',
                'Required parameter "generateInvoicesRequest" was null or undefined when calling apiPaymentsInvoicesGeneratePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices/generate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateInvoicesRequestToJSON(requestParameters['generateInvoicesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiUserTasksGetLastSelectedIdParameterFromJSON));
    }

    /**
     * Initiates invoice generation based on the specified criteria and returns the identifiers of the invoices queued for generation.
     * Generate invoices
     */
    async apiPaymentsInvoicesGeneratePost(requestParameters: ApiPaymentsInvoicesGeneratePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApiUserTasksGetLastSelectedIdParameter>> {
        const response = await this.apiPaymentsInvoicesGeneratePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the specified invoice.
     * Delete invoice
     */
    async apiPaymentsInvoicesInvoiceIdDeleteRaw(requestParameters: ApiPaymentsInvoicesInvoiceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling apiPaymentsInvoicesInvoiceIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices/{invoiceId}`;
        urlPath = urlPath.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the specified invoice.
     * Delete invoice
     */
    async apiPaymentsInvoicesInvoiceIdDelete(requestParameters: ApiPaymentsInvoicesInvoiceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsInvoicesInvoiceIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific invoice by its identifier.
     * Get invoice
     */
    async apiPaymentsInvoicesInvoiceIdGetRaw(requestParameters: ApiPaymentsInvoicesInvoiceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceResponse>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling apiPaymentsInvoicesInvoiceIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices/{invoiceId}`;
        urlPath = urlPath.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific invoice by its identifier.
     * Get invoice
     */
    async apiPaymentsInvoicesInvoiceIdGet(requestParameters: ApiPaymentsInvoicesInvoiceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceResponse> {
        const response = await this.apiPaymentsInvoicesInvoiceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiates the release of payment for the specified invoice.
     * Release invoice payment
     */
    async apiPaymentsInvoicesInvoiceIdReleasePostRaw(requestParameters: ApiPaymentsInvoicesInvoiceIdReleasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceActionResponse>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling apiPaymentsInvoicesInvoiceIdReleasePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices/{invoiceId}/release`;
        urlPath = urlPath.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceActionResponseFromJSON(jsonValue));
    }

    /**
     * Initiates the release of payment for the specified invoice.
     * Release invoice payment
     */
    async apiPaymentsInvoicesInvoiceIdReleasePost(requestParameters: ApiPaymentsInvoicesInvoiceIdReleasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceActionResponse> {
        const response = await this.apiPaymentsInvoicesInvoiceIdReleasePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiates sending the statement for the specified invoice.
     * Send invoice statement
     */
    async apiPaymentsInvoicesInvoiceIdStatementPostRaw(requestParameters: ApiPaymentsInvoicesInvoiceIdStatementPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceActionResponse>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling apiPaymentsInvoicesInvoiceIdStatementPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices/{invoiceId}/statement`;
        urlPath = urlPath.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceActionResponseFromJSON(jsonValue));
    }

    /**
     * Initiates sending the statement for the specified invoice.
     * Send invoice statement
     */
    async apiPaymentsInvoicesInvoiceIdStatementPost(requestParameters: ApiPaymentsInvoicesInvoiceIdStatementPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceActionResponse> {
        const response = await this.apiPaymentsInvoicesInvoiceIdStatementPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of invoices based on the specified filtering and pagination criteria.
     * Get invoices
     */
    async apiPaymentsInvoicesPostRaw(requestParameters: ApiPaymentsInvoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfInvoiceResponse>> {
        if (requestParameters['getInvoicesRequest'] == null) {
            throw new runtime.RequiredError(
                'getInvoicesRequest',
                'Required parameter "getInvoicesRequest" was null or undefined when calling apiPaymentsInvoicesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetInvoicesRequestToJSON(requestParameters['getInvoicesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfInvoiceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of invoices based on the specified filtering and pagination criteria.
     * Get invoices
     */
    async apiPaymentsInvoicesPost(requestParameters: ApiPaymentsInvoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfInvoiceResponse> {
        const response = await this.apiPaymentsInvoicesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns invoice counts for the last 12 months, grouped by invoice date and billing date. Vault counts reflect the selected vault stored on each invoice when it was generated.
     * Get invoice summaries
     */
    async apiPaymentsInvoicesSummaryGetRaw(requestParameters: ApiPaymentsInvoicesSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvoiceSummaryResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['invoiceDate'] != null) {
            queryParameters['invoiceDate'] = requestParameters['invoiceDate'];
        }

        if (requestParameters['billingDate'] != null) {
            queryParameters['billingDate'] = requestParameters['billingDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/invoices/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceSummaryResponseFromJSON));
    }

    /**
     * Returns invoice counts for the last 12 months, grouped by invoice date and billing date. Vault counts reflect the selected vault stored on each invoice when it was generated.
     * Get invoice summaries
     */
    async apiPaymentsInvoicesSummaryGet(requestParameters: ApiPaymentsInvoicesSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvoiceSummaryResponse>> {
        const response = await this.apiPaymentsInvoicesSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the current open balance for a student and currency.
     * Get open balance
     */
    async apiPaymentsOpenBalanceGetRaw(requestParameters: ApiPaymentsOpenBalanceGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OpenBalanceResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['billingDate'] != null) {
            queryParameters['BillingDate'] = requestParameters['billingDate'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['UserId'] = requestParameters['userId'];
        }

        if (requestParameters['studentId'] != null) {
            queryParameters['StudentId'] = requestParameters['studentId'];
        }

        if (requestParameters['currency'] != null) {
            queryParameters['Currency'] = requestParameters['currency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/open-balance`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OpenBalanceResponseFromJSON));
    }

    /**
     * Gets the current open balance for a student and currency.
     * Get open balance
     */
    async apiPaymentsOpenBalanceGet(requestParameters: ApiPaymentsOpenBalanceGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OpenBalanceResponse>> {
        const response = await this.apiPaymentsOpenBalanceGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recomputes all balance coverage for a student after a manual amount correction. Requires an administrator and a reason.
     * Rebuild student balance
     */
    async apiPaymentsRebuildBalanceStudentIdPutRaw(requestParameters: ApiPaymentsRebuildBalanceStudentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studentId'] == null) {
            throw new runtime.RequiredError(
                'studentId',
                'Required parameter "studentId" was null or undefined when calling apiPaymentsRebuildBalanceStudentIdPut().'
            );
        }

        if (requestParameters['rebuildCoverageRequest'] == null) {
            throw new runtime.RequiredError(
                'rebuildCoverageRequest',
                'Required parameter "rebuildCoverageRequest" was null or undefined when calling apiPaymentsRebuildBalanceStudentIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/rebuild-balance/{studentId}`;
        urlPath = urlPath.replace(`{${"studentId"}}`, encodeURIComponent(String(requestParameters['studentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RebuildCoverageRequestToJSON(requestParameters['rebuildCoverageRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Recomputes all balance coverage for a student after a manual amount correction. Requires an administrator and a reason.
     * Rebuild student balance
     */
    async apiPaymentsRebuildBalanceStudentIdPut(requestParameters: ApiPaymentsRebuildBalanceStudentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsRebuildBalanceStudentIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Recomputes all coverage for a student after a manual amount correction. Requires an administrator and a reason.
     * Rebuild student balance coverage
     */
    async apiPaymentsRebuildCoverageStudentIdPutRaw(requestParameters: ApiPaymentsRebuildCoverageStudentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studentId'] == null) {
            throw new runtime.RequiredError(
                'studentId',
                'Required parameter "studentId" was null or undefined when calling apiPaymentsRebuildCoverageStudentIdPut().'
            );
        }

        if (requestParameters['rebuildCoverageRequest'] == null) {
            throw new runtime.RequiredError(
                'rebuildCoverageRequest',
                'Required parameter "rebuildCoverageRequest" was null or undefined when calling apiPaymentsRebuildCoverageStudentIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/rebuild-coverage/{studentId}`;
        urlPath = urlPath.replace(`{${"studentId"}}`, encodeURIComponent(String(requestParameters['studentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RebuildCoverageRequestToJSON(requestParameters['rebuildCoverageRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Recomputes all coverage for a student after a manual amount correction. Requires an administrator and a reason.
     * Rebuild student balance coverage
     */
    async apiPaymentsRebuildCoverageStudentIdPut(requestParameters: ApiPaymentsRebuildCoverageStudentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsRebuildCoverageStudentIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Reconcile the student\'s outstanding balance.
     * Reconcile student balance
     */
    async apiPaymentsReconcileStudentIdPutRaw(requestParameters: ApiPaymentsReconcileStudentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studentId'] == null) {
            throw new runtime.RequiredError(
                'studentId',
                'Required parameter "studentId" was null or undefined when calling apiPaymentsReconcileStudentIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/reconcile/{studentId}`;
        urlPath = urlPath.replace(`{${"studentId"}}`, encodeURIComponent(String(requestParameters['studentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reconcile the student\'s outstanding balance.
     * Reconcile student balance
     */
    async apiPaymentsReconcileStudentIdPut(requestParameters: ApiPaymentsReconcileStudentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsReconcileStudentIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Refund a payment transaction by its ID. This endpoint will initiate a refund process for the specified payment transaction.
     * Refund transaction
     */
    async apiPaymentsRefundPutRaw(requestParameters: ApiPaymentsRefundPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['refundPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'refundPaymentRequest',
                'Required parameter "refundPaymentRequest" was null or undefined when calling apiPaymentsRefundPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/refund`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RefundPaymentRequestToJSON(requestParameters['refundPaymentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Refund a payment transaction by its ID. This endpoint will initiate a refund process for the specified payment transaction.
     * Refund transaction
     */
    async apiPaymentsRefundPut(requestParameters: ApiPaymentsRefundPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsRefundPutRaw(requestParameters, initOverrides);
    }

    /**
     * Release a previously reserved payment for a user\'s account.
     * Release family payment
     */
    async apiPaymentsReleaseFamilyPaymentPostRaw(requestParameters: ApiPaymentsReleaseFamilyPaymentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['releaseFamilyPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'releaseFamilyPaymentRequest',
                'Required parameter "releaseFamilyPaymentRequest" was null or undefined when calling apiPaymentsReleaseFamilyPaymentPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/release-family-payment`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReleaseFamilyPaymentRequestToJSON(requestParameters['releaseFamilyPaymentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Release a previously reserved payment for a user\'s account.
     * Release family payment
     */
    async apiPaymentsReleaseFamilyPaymentPost(requestParameters: ApiPaymentsReleaseFamilyPaymentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsReleaseFamilyPaymentPostRaw(requestParameters, initOverrides);
    }

    /**
     * Release a previously reserved payment for a user\'s account.
     * Release payment
     */
    async apiPaymentsReleasePostRaw(requestParameters: ApiPaymentsReleasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['releasePaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'releasePaymentRequest',
                'Required parameter "releasePaymentRequest" was null or undefined when calling apiPaymentsReleasePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/release`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReleasePaymentRequestToJSON(requestParameters['releasePaymentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Release a previously reserved payment for a user\'s account.
     * Release payment
     */
    async apiPaymentsReleasePost(requestParameters: ApiPaymentsReleasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsReleasePostRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a paginated list of payments.
     * Scroll payments
     */
    async apiPaymentsScrollPostRaw(requestParameters: ApiPaymentsScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetPaymentResponse>> {
        if (requestParameters['scrollPaymentsQuery'] == null) {
            throw new runtime.RequiredError(
                'scrollPaymentsQuery',
                'Required parameter "scrollPaymentsQuery" was null or undefined when calling apiPaymentsScrollPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScrollPaymentsQueryToJSON(requestParameters['scrollPaymentsQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetPaymentResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of payments.
     * Scroll payments
     */
    async apiPaymentsScrollPost(requestParameters: ApiPaymentsScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetPaymentResponse> {
        const response = await this.apiPaymentsScrollPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends the user\'s invoice by email.
     * Send invoice
     */
    async apiPaymentsStatementEmailPostRaw(requestParameters: ApiPaymentsStatementEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatementEmailResponse>> {
        if (requestParameters['sendStatementEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendStatementEmailRequest',
                'Required parameter "sendStatementEmailRequest" was null or undefined when calling apiPaymentsStatementEmailPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/statement/email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendStatementEmailRequestToJSON(requestParameters['sendStatementEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatementEmailResponseFromJSON(jsonValue));
    }

    /**
     * Sends the user\'s invoice by email.
     * Send invoice
     */
    async apiPaymentsStatementEmailPost(requestParameters: ApiPaymentsStatementEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatementEmailResponse> {
        const response = await this.apiPaymentsStatementEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the status of a queued payment work item.
     * Get payment status
     */
    async apiPaymentsStatusWorkItemIdGetRaw(requestParameters: ApiPaymentsStatusWorkItemIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentWorkItemResponse>> {
        if (requestParameters['workItemId'] == null) {
            throw new runtime.RequiredError(
                'workItemId',
                'Required parameter "workItemId" was null or undefined when calling apiPaymentsStatusWorkItemIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/status/{workItemId}`;
        urlPath = urlPath.replace(`{${"workItemId"}}`, encodeURIComponent(String(requestParameters['workItemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentWorkItemResponseFromJSON(jsonValue));
    }

    /**
     * Gets the status of a queued payment work item.
     * Get payment status
     */
    async apiPaymentsStatusWorkItemIdGet(requestParameters: ApiPaymentsStatusWorkItemIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentWorkItemResponse> {
        const response = await this.apiPaymentsStatusWorkItemIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retries a failed payment release when no payment transaction was created. Existing transactions require reconciliation first.
     * Retry a failed payment
     */
    async apiPaymentsStatusWorkItemIdRetryPostRaw(requestParameters: ApiPaymentsStatusWorkItemIdRetryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workItemId'] == null) {
            throw new runtime.RequiredError(
                'workItemId',
                'Required parameter "workItemId" was null or undefined when calling apiPaymentsStatusWorkItemIdRetryPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/status/{workItemId}/retry`;
        urlPath = urlPath.replace(`{${"workItemId"}}`, encodeURIComponent(String(requestParameters['workItemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retries a failed payment release when no payment transaction was created. Existing transactions require reconciliation first.
     * Retry a failed payment
     */
    async apiPaymentsStatusWorkItemIdRetryPost(requestParameters: ApiPaymentsStatusWorkItemIdRetryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsStatusWorkItemIdRetryPostRaw(requestParameters, initOverrides);
    }

    /**
     * Validates terminal surcharge for the specified payment context. If a surcharge disclosure is configured, it must be accepted before payment can proceed. If no surcharge disclosure is configured, the validation succeeds.
     * Validate surcharge
     */
    async apiPaymentsSurchargeDisclosureValidatePostRaw(requestParameters: ApiPaymentsSurchargeDisclosureValidatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTerminalResponse>> {
        if (requestParameters['validateSurchargeRequest'] == null) {
            throw new runtime.RequiredError(
                'validateSurchargeRequest',
                'Required parameter "validateSurchargeRequest" was null or undefined when calling apiPaymentsSurchargeDisclosureValidatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/surcharge-disclosure/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateSurchargeRequestToJSON(requestParameters['validateSurchargeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTerminalResponseFromJSON(jsonValue));
    }

    /**
     * Validates terminal surcharge for the specified payment context. If a surcharge disclosure is configured, it must be accepted before payment can proceed. If no surcharge disclosure is configured, the validation succeeds.
     * Validate surcharge
     */
    async apiPaymentsSurchargeDisclosureValidatePost(requestParameters: ApiPaymentsSurchargeDisclosureValidatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTerminalResponse> {
        const response = await this.apiPaymentsSurchargeDisclosureValidatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint allows you to fetch payment transactions associated with a particular user. You can specify the user ID and additional parameters such as student ID and limit for pagination.
     * Get payments by User ID
     */
    async apiPaymentsUserUserIdGetRaw(requestParameters: ApiPaymentsUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPaymentResponse>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiPaymentsUserUserIdGet().'
            );
        }

        if (requestParameters['getPaymentByUserIdRequest'] == null) {
            throw new runtime.RequiredError(
                'getPaymentByUserIdRequest',
                'Required parameter "getPaymentByUserIdRequest" was null or undefined when calling apiPaymentsUserUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: GetPaymentByUserIdRequestToJSON(requestParameters['getPaymentByUserIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPaymentResponseFromJSON));
    }

    /**
     * This endpoint allows you to fetch payment transactions associated with a particular user. You can specify the user ID and additional parameters such as student ID and limit for pagination.
     * Get payments by User ID
     */
    async apiPaymentsUserUserIdGet(requestParameters: ApiPaymentsUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPaymentResponse>> {
        const response = await this.apiPaymentsUserUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify a payment transaction by its token ID. This endpoint will verify the specified payment transaction.
     * Verify transaction
     */
    async apiPaymentsVerifyPostRaw(requestParameters: ApiPaymentsVerifyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyPayJunctionResponse>> {
        if (requestParameters['verifyPayJunctionRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyPayJunctionRequest',
                'Required parameter "verifyPayJunctionRequest" was null or undefined when calling apiPaymentsVerifyPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/verify`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyPayJunctionRequestToJSON(requestParameters['verifyPayJunctionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyPayJunctionResponseFromJSON(jsonValue));
    }

    /**
     * Verify a payment transaction by its token ID. This endpoint will verify the specified payment transaction.
     * Verify transaction
     */
    async apiPaymentsVerifyPost(requestParameters: ApiPaymentsVerifyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyPayJunctionResponse> {
        const response = await this.apiPaymentsVerifyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Void a payment transaction by its ID. This endpoint will initiate a void process for the specified payment transaction.
     * Void transaction
     */
    async apiPaymentsVoidPutRaw(requestParameters: ApiPaymentsVoidPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['voidPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'voidPaymentRequest',
                'Required parameter "voidPaymentRequest" was null or undefined when calling apiPaymentsVoidPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/payments/void`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VoidPaymentRequestToJSON(requestParameters['voidPaymentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Void a payment transaction by its ID. This endpoint will initiate a void process for the specified payment transaction.
     * Void transaction
     */
    async apiPaymentsVoidPut(requestParameters: ApiPaymentsVoidPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPaymentsVoidPutRaw(requestParameters, initOverrides);
    }

}
